// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"52cc643f","455":"713ea2f9","977":"760315ec"}[chunkId] + ".chunk.js";
};